import { FC } from 'react';

import Heading from '@/components/elements/Heading';
import PreHeading from '@/components/elements/PreHeading';

export interface StatsRowProps {
  uid: any;
  stats: any;
}

const StatsRow: FC<StatsRowProps> = ({ uid, stats }) => {
  return (
    <dl
      key={uid}
      className="not-prose flex flex-wrap items-center justify-center gap-16 py-4 md:gap-24 md:py-8"
    >
      {stats.map((stat) => (
        <div key={stat?._uid} className="flex flex-col">
          <PreHeading
            size="xs"
            color="black"
            element="dt"
            className={`border-lift-black/20 pt-6 mt-4 ${
              stat.position === 'above'
                ? 'border-t order-2'
                : 'border-b order-1'
            }`}
          >
            {stat.label}
          </PreHeading>
          <Heading
            size="lg"
            color="black"
            element="dd"
            className={`${stat.position === 'above' ? 'order-1' : 'order-2'}`}
          >
            {stat.stat}
          </Heading>
        </div>
      ))}
    </dl>
  );
};

export default StatsRow;
